import React, { useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { useParams } from "react-router";
import moment from "moment";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { getUsersRefferalDeatils } from "services/userReferrals.service";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import Breadcrumbs from "components/Common/Breadcrumb";
import Spinner from "components/spinner";

const SelectedUserRefferals = () => {
  const { code } = useParams();
  const { SearchBar } = Search;
  const [loading, setLoading] = useState(false);
  const [usersTotalReferralList, setUserTotaleferralListData] = useState([]);
  const [usersReferralList, setUserReferralListData] = useState([]);

  console.log(usersTotalReferralList, code, "usersReferralList");
  useEffect(() => {
    if (code) getUsersList(code);
  }, [code]);

  const getUsersList = code => {
    setLoading(true);
    getUsersRefferalDeatils(code)
      .then(res => {
        const referralData = res.data[0];
        setUserTotaleferralListData(referralData);
        setUserReferralListData(referralData?.referees || []);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.log(err, "error in getUsersrefferalList");
      });
  };

  const handleRoute = serverData => {
    if (serverData?.orderId?.orderId) {
      window.open(`/orders?orderId=${serverData.orderId.orderId}`, "_blank");
    }
  };

  const columns = [
    {
      dataField: "_id",
      text: "#",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
    },
    {
      dataField: "userDetails.firstname",
      text: "First Name",
      formatter: (cell, row) =>
        row?.userDetails?.firstname + " " + row?.userDetails?.lastname || "-",
    },

    {
      dataField: "userDetails.email",
      text: "Email",
      formatter: (cell, row) => row?.userDetails?.email || "-",
    },
    {
      dataField: "userDetails.mobilenumber",
      text: "Mobile Number",
      formatter: (cell, row) => row?.userDetails?.mobilenumber || "-",
    },

    {
      dataField: "referredAt",
      text: "Referred At",
      formatter: cell =>
        cell ? moment(cell).format("DD-MMM-YYYY hh:mm A") : "-",
    },
    {
      dataField: "isBooked",
      text: "First Order Placed",
    },
  ];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: usersReferralList.length,
    custom: true,
  };

  return (
    <div className="page-content">
      <MetaTags>
        <title>User Referrals</title>
      </MetaTags>

      <Container fluid>
        <Breadcrumbs
          title="User Referrals"
          breadcrumbItem="User Referrals List"
        />
        <BreadcrumbSub
          subtile="Users Referrals List"
          SubBreadcrumbItem="Referrals List"
        />

        <Row className="mt-3">
          <Col>
            <Card>
              <CardBody>
                <PaginationProvider
                  pagination={paginationFactory(pageOptions)}
                  keyField="_id"
                  columns={columns}
                  data={usersReferralList}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={usersReferralList}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex flex-wrap gap-3">
                              <div>
                                <strong>Referred User Name: </strong>
                                {"  "}
                                {"  "}
                                {
                                  usersTotalReferralList?.referrerDetails
                                    ?.firstname
                                }{" "}
                                {
                                  usersTotalReferralList?.referrerDetails
                                    ?.lastname
                                }
                              </div>
                              <div>
                                <strong>Referral Code: </strong>
                                {"  "}
                                {usersTotalReferralList?.referralCodeUpperCase}
                              </div>
                            </div>
                            <div className="search-box">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>

                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField="_id"
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  classes="table align-middle table-nowrap table-check"
                                  headerWrapperClasses="table-light"
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="align-items-md-center mt-3">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>

                {usersReferralList.length === 0 && (
                  <p className="text-center">No Data Found</p>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Spinner loading={loading} />
      </Container>
    </div>
  );
};

export default SelectedUserRefferals;
